import { defaultMapper } from '@/common/service/default-mapper';
import { planTypes } from '@/common/constants';

export const BASE_UNIT = 1024;

export const zcmStorageCapacityMap = {
  zcm_storage_30: { capacity: 30 },
  zcm_storage_200: { capacity: 200 },
  zcm_storage_1tb: { capacity: BASE_UNIT },
  zcm_storage_5tb: { capacity: BASE_UNIT * 5 },
};

export default (planMapJSON) => {
  // Free users can't buy ZCM Storage directly, 
  // they have to buy ZCM first and then add it.
  if (!window.$context.is.add2cart && !window.$context.is.edit) {
    return []
  }
  return Object.keys(zcmStorageCapacityMap).reduce((pre, key) => {
    const plan = planMapJSON[key] || {};
    const { capacity } = zcmStorageCapacityMap[key] || {};

    return [
      ...pre,
      ...defaultMapper(plan, planTypes.ZCM_STORAGE).map((item) => {
        return {
          ...item,
          capacity,
          cartCapacityUnit: capacity < BASE_UNIT ? 'GB' : 'TB',
          cartCapacity: capacity < BASE_UNIT ? capacity : Math.floor(capacity / BASE_UNIT),
          typeNameKey: 'billing.zcm_storage.title',
          planNameKey: 'billing.zcm_storage.title',
        };
      }),
    ];
  }, []);
};
